export const BOOKS_PER_PAGE = 30;
